import {
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  styled,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import apiService from "../../../service/apiservice/apiService";
import { useGetOrgIdentifier } from "../../generic/hooks/useGetOrgIdentifier";

const CustomOutlinedInput = styled(OutlinedInput)(({ theme }) => ({
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "var(--main-theme-color) !important",
    borderWidth: "1px !important",
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const FacilityTypeSelect = ({ facilityDetails, handleChange }) => {
  const organizationIdentifier = useGetOrgIdentifier();
  const [facilityTypes, setFacilityTypes] = useState([]);

  useEffect(() => {
    const getFacilityTypes = async () => {
      const endpoint = "niramayafoundation/api/v1/facilities/types";
      const params = {
        facilityTypeOrganizationId: organizationIdentifier,
      };
      const response = await apiService.get(endpoint, params);
      setFacilityTypes(response);
    };

    getFacilityTypes();
  }, [organizationIdentifier]);

  return (
    <FormControl fullWidth className="add-edit-select">
      <InputLabel id={`facility-type`}>Facility Type</InputLabel>
      <Select
        labelId={`facility-type`}
        value={facilityDetails?.facilityTypeId}
        label={"Facility Type"}
        onChange={handleChange}
        MenuProps={MenuProps}
        name={"facilityTypeId"}
        input={<CustomOutlinedInput label={"Facility Type"} />}
      >
        {facilityTypes?.map((item) => (
          <MenuItem value={item?.facilityTypeId} key={item?.facilityTypeId}>
            {item?.facilityTypeDescription}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FacilityTypeSelect;
